// Libraries
import { TypeOf, z } from 'zod';
// Schemas
import { buildResponse } from './global';

export const PresignedURLSchema = z.object({
  objectKey: z.string(),
  presignedURL: z.string(),
});

export const PresignedURLDataSchema = buildResponse(PresignedURLSchema);

export type PresignedURLData = TypeOf<typeof PresignedURLSchema>;
